var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M19.335 4.665a.94.94 0 0 1-.008 1.316L5.964 19.344a.91.91 0 0 1-1.3-.009.94.94 0 0 1 .01-1.316L18.035 4.656a.91.91 0 0 1 1.3.009",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M4.665 4.665a.91.91 0 0 1 1.3-.009L19.326 18.02a.94.94 0 0 1 .008 1.316.91.91 0 0 1-1.299.009L4.673 5.98a.94.94 0 0 1-.008-1.316",
  clipRule: "evenodd"
})));
export default SvgDelete;